var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFileText = function SvgFileText(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3F46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.667 1.714v.953c0 1.4 0 2.1.273 2.634a2.5 2.5 0 0 0 1.092 1.093c.535.272 1.235.272 2.635.272h.952m-4.952-4.952c-.328-.047-.72-.047-1.376-.047H8.667c-1.867 0-2.8 0-3.513.363-.627.32-1.137.83-1.457 1.457C3.334 4.2 3.334 5.133 3.334 7v6c0 1.867 0 2.8.363 3.513.32.627.83 1.137 1.457 1.457.713.363 1.646.363 3.513.363h2.667c1.867 0 2.8 0 3.513-.363a3.334 3.334 0 0 0 1.457-1.457c.363-.713.363-1.646.363-3.513V8.042c0-.655 0-1.048-.048-1.375m-4.952-4.953a3.333 3.333 0 0 1 1.194.443c.337.207.625.495 1.202 1.072l1.042 1.042c.577.577.865.865 1.071 1.201.183.298.318.624.4.964.017.075.032.15.043.23m-9.952 4.167h6.667m-6.667 3.333h4.167"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFileText);
export default ForwardRef;